import EditorFeatureTitle from "../../components/editor/EditorFeatureTitle"
import EditorFeatureSubtitle from "../../components/editor/EditorFeatureSubtitle"

const Sentiments = () => {
	return (
		<div className='bg-white shadow-sm lg:p-9 xl:p-9 2xl:p-10'>
			<EditorFeatureTitle title='Sentiments' />
			<EditorFeatureSubtitle>
				Lorem ipsum dolor sit amet, consectetur adipiscing elit
			</EditorFeatureSubtitle>
			<div className='lg:space-y-4  2xl:space-y-5 lg:mt-7 xl:mt-8 2xl:mt-9'>
				<div className='lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db'>
					<div className='flex items-center space-x-2'>
						<div className='flex-none text-ef text-lg font-semibold'>Happy</div>
						<div className='relative bg-7d rounded-full h-2 flex-1 bg-opacity-20'>
							<div className='absolute inset-y-0 left-0 w-4/5 bg-ef rounded-full'></div>
						</div>
					</div>
					<div className='text-xl text-1b mt-3'>
						Fiverr was founded by Micha Kaufman and Shai Wininger and was launched in February 2010
					</div>
				</div>
				<div className='flex lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center justify-between'>
					<div className='text-xl font-bold text-1b'>The founders came up with the…</div>
					<div className='text-lg text-7d'>Neutral</div>
				</div>
				<div className='flex lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center justify-between'>
					<div className='text-xl font-bold text-1b'>Services offered on the site…</div>
					<div className='text-lg text-7d'>Serious</div>
				</div>
			</div>
		</div>
	)
}

export default Sentiments